import React from "react";

import { useLocation } from "react-router-dom";

import { isCLevelPath } from "../../helpers/isCLevelPath";
import { SmallTitle } from "../../styles/sharedStyles"
import { ButtonAnchor } from "../ButtonAnchor/ButtonAnchor";

import {
  MainTitle,
  Section,
  Text,
} from "./styles"

type TInfoSection = {
  backgroundImage?: string;
  buttonTitle?: string;
}

export const ConsultationBanner: React.FC<TInfoSection> = ({
  backgroundImage,
  buttonTitle,
}) => {

  const location = useLocation();
  const isITTrainingPage = location.pathname === "/services/it-training";
  const isCLevelPage = isCLevelPath(location.pathname);
  const defaultButtonTitle = isITTrainingPage ? "Получить консультацию" : "Оставить заявку";

  return (
    <Section
      bgImage={backgroundImage}
      isCLevelPage={isCLevelPage}
    >
      <SmallTitle isWhite>
        бесплатная консультация
      </SmallTitle>
      <MainTitle>
        {isITTrainingPage ? "Оставить заявку" : "Остались вопросы ?"}
      </MainTitle>
      <Text>Консультация-знакомство это возможность получить ответы
       на все волнующие вопросы.
      </Text>
      <ButtonAnchor
        href="https://t.me/ProhorovaConsult?text=Здравствуйте! Хочу подробнее узнать об услугах"
        title={buttonTitle || defaultButtonTitle}
      />
    </Section>
  );
};
